export class CityDropdownController {
  constructor(controller) {
    this.controller = controller;
  }

  // ========================================
  // 市区町村ドロップダウン
  // ========================================

  toggleCityDropdown(event) {
    event.stopPropagation();

    // 都道府県が選択されていない場合は何もしない
    if (!this.controller.selectedPrefecture) {
      return;
    }

    this.controller.prefectureDropdownController.closePrefectureDropdown();

    const dropdown = this.controller.cityDropdownTarget;

    if (dropdown) {
      if (dropdown.style.display === 'none' || dropdown.style.display === '') {
        dropdown.style.display = 'block';
      } else {
        dropdown.style.display = 'none';
      }
    }
  }

  closeCityDropdown() {
    if (this.controller.hasCityDropdownTarget) {
      this.controller.cityDropdownTarget.style.display = 'none';
    }
  }

  // ========================================
  // 市区町村データ取得
  // ========================================

  async loadCities(prefectureName) {
    if (!prefectureName) {
      return;
    }

    try {
      // 政令指定都市と市区町村を取得（区は除外済み）
      const response = await fetch(`/api/prefecture/${encodeURIComponent(prefectureName)}/cities_with_major`);

      if (!response.ok) {
        this.showErrorMessage('市区町村の取得に失敗しました。もう一度お試しください。');
        return;
      }

      const cities = await response.json();

      // 全市区町村を有効として保存
      this.controller.cities = cities.map(city => ({
        ...city,
        enabled: true
      }));

      // 市区町村ボタンを生成
      this.renderCityButtons();
    } catch {
      this.showErrorMessage('市区町村の取得中にエラーが発生しました。もう一度お試しください。');
    }
  }

  showErrorMessage(message) {
    this.controller.cityButtonsContainerTarget.textContent = '';
    const errorDiv = document.createElement('div');
    errorDiv.className = 'subsidies-search-panel__dropdown-error';
    errorDiv.textContent = message;
    this.controller.cityButtonsContainerTarget.appendChild(errorDiv);
  }

  // ========================================
  // 市区町村リスト表示
  // ========================================

  renderCityButtons() {
    const container = this.controller.cityButtonsContainerTarget;
    container.textContent = '';
    this.renderCityButtonsInContainer(container);
  }

  renderCityButtonsInContainer(container) {
    // 五十音順のグループ定義
    const kanaGroups = [
      { group: 'あ', kanas: ['ア', 'イ', 'ウ', 'エ', 'オ'] },
      { group: 'か', kanas: ['カ', 'キ', 'ク', 'ケ', 'コ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ'] },
      { group: 'さ', kanas: ['サ', 'シ', 'ス', 'セ', 'ソ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'] },
      { group: 'た', kanas: ['タ', 'チ', 'ツ', 'テ', 'ト', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'] },
      { group: 'な', kanas: ['ナ', 'ニ', 'ヌ', 'ネ', 'ノ'] },
      { group: 'は', kanas: ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ'] },
      { group: 'ま', kanas: ['マ', 'ミ', 'ム', 'メ', 'モ'] },
      { group: 'や', kanas: ['ヤ', 'ユ', 'ヨ'] },
      { group: 'ら', kanas: ['ラ', 'リ', 'ル', 'レ', 'ロ'] },
      { group: 'わ', kanas: ['ワ', 'ヲ', 'ン'] }
    ];

    const kanaGroupData = [];

    kanaGroups.forEach(({ group, kanas }) => {
      const groupCities = this.controller.cities.filter(city => {
        if (!city.yomi) return false;
        const firstChar = city.yomi.slice(0, 1);
        return kanas.includes(firstChar);
      });

      if (groupCities.length > 0) {
        kanaGroupData.push({ kana: group, cities: groupCities });
      }
    });

    kanaGroupData.forEach((group) => {
      if (group.cities.length > 0) {
        const groupTitle = document.createElement('div');
        groupTitle.className = 'subsidies-search-panel__dropdown-city-group-title';
        groupTitle.textContent = `${group.kana}行`;
        container.appendChild(groupTitle);

        const groupButtons = document.createElement('div');
        groupButtons.className = 'subsidies-search-panel__dropdown-city-group-buttons';

        group.cities.forEach(city => {
          const button = document.createElement('button');
          button.className = 'subsidies-search-panel__dropdown-button';
          button.type = 'button';
          button.textContent = city.name;
          button.dataset.cityId = city.id;
          button.dataset.cityName = city.name;

          if (city.enabled) {
            button.dataset.action = 'click->refosumu-subsidies-search-panel#selectCity';
          } else {
            button.classList.add('disabled');
            button.disabled = true;
          }

          groupButtons.appendChild(button);
        });

        container.appendChild(groupButtons);
      }
    });
  }

  // ========================================
  // 市区町村選択
  // ========================================

  selectCity(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const cityId = button.dataset.cityId;
    const cityName = button.dataset.cityName;

    // 前回選択された市区町村ボタンのselectedクラスを削除
    const allButtons = this.controller.cityDropdownTarget.querySelectorAll('.subsidies-search-panel__dropdown-button');
    allButtons.forEach(btn => btn.classList.remove('selected'));

    // 新しく選択されたボタンにselectedクラスを追加
    button.classList.add('selected');

    // 選択状態を更新
    this.controller.selectedCity = cityId;
    this.controller.selectedCityName = cityName;

    // hidden fieldを更新
    if (this.controller.hasCityHiddenFieldTarget) {
      this.controller.cityHiddenFieldTarget.value = cityId;
    }

    // ドロップダウンを閉じる
    this.closeCityDropdown();

    // ドロップダウンを非表示にしてピル型ボタンを表示
    this.showCitySelectedPill(cityName);
  }

  showCitySelectedPill(cityName) {
    // テキストを非表示
    if (this.controller.hasCityTextTarget) {
      this.controller.cityTextTarget.style.display = 'none';
    }

    // ピル型ボタンを表示
    if (this.controller.hasCitySelectedPillTarget) {
      this.controller.citySelectedPillTarget.style.display = 'flex';
    }

    // 市区町村名を設定
    if (this.controller.hasCitySelectedTextTarget) {
      this.controller.citySelectedTextTarget.textContent = cityName;
    }

    // セレクトボックスの下矢印を非表示にし、アイコンをオレンジにするためクラス追加
    if (this.controller.hasCityInputTarget) {
      this.controller.cityInputTarget.classList.add('subsidies-search-panel__select--has-pill');
      this.controller.cityInputTarget.classList.add('subsidies-search-panel__select--selected');
    }
  }

  hideCitySelectedPill() {
    // ピル型ボタンを非表示
    if (this.controller.hasCitySelectedPillTarget) {
      this.controller.citySelectedPillTarget.style.display = 'none';
    }

    // テキストを表示
    if (this.controller.hasCityTextTarget) {
      this.controller.cityTextTarget.style.display = '';
    }

    // セレクトボックスの下矢印を表示し、アイコンを元に戻すためクラス削除
    if (this.controller.hasCityInputTarget) {
      this.controller.cityInputTarget.classList.remove('subsidies-search-panel__select--has-pill');
      this.controller.cityInputTarget.classList.remove('subsidies-search-panel__select--selected');
    }
  }

  clearCity(event) {
    event.stopPropagation();
    event.preventDefault();

    // 選択状態をリセット
    this.controller.selectedCity = null;
    this.controller.selectedCityName = null;

    // hidden fieldをリセット
    if (this.controller.hasCityHiddenFieldTarget) {
      this.controller.cityHiddenFieldTarget.value = '';
    }

    // ピル型ボタンを非表示にしてテキストを表示
    this.hideCitySelectedPill();

    // テキストを「指定なし」に戻す
    if (this.controller.hasCityTextTarget) {
      this.controller.cityTextTarget.textContent = '指定なし';
    }

    // ドロップダウン内の選択状態をリセット
    if (this.controller.hasCityDropdownTarget) {
      const allButtons = this.controller.cityDropdownTarget.querySelectorAll('.subsidies-search-panel__dropdown-button');
      allButtons.forEach(btn => btn.classList.remove('selected'));
    }
  }
}
